import React from 'react';
import {NavLink} from "react-router-dom";


const CustomLink = ({to, label}) => {

    const defaultClass = 'p-3 px-5 font-bold text-green-900 hover:bg-gray-300 hover:bg-opacity-50 cursor-pointer';
    const inactiveClass = defaultClass + ' border-transparent';
    const activeClass = defaultClass + ' border-b-4 border-green-900';

    return (
        <NavLink to={to} replace={true} className={({isActive}) => isActive ? activeClass : inactiveClass}>
            {label}
        </NavLink>
    );
};

export default CustomLink;